var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 1.5L18.4448 3.75L21 4.0605L19.125 5.75025L19.5 8.25L17.25 6.84375L15 8.25L15.375 5.75025L13.5 4.0605L16.125 3.75L17.25 1.5Z",
    fill: "#334863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0381 9.93676L15.5846 9.56326C15.3241 10.5669 14.7719 11.4709 13.9979 12.1609C13.2238 12.8509 12.2626 13.296 11.2357 13.44C10.2088 13.5839 9.16231 13.4203 8.22835 12.9698C7.29439 12.5193 6.51492 11.802 5.98841 10.9087C5.4619 10.0154 5.21197 8.98602 5.2702 7.95071C5.32843 6.9154 5.69221 5.92058 6.31557 5.09192C6.93894 4.26326 7.79392 3.63795 8.7725 3.29499C9.75109 2.95202 10.8094 2.90679 11.8136 3.16501L12.1879 1.71226C10.7239 1.33145 9.17434 1.45402 7.78841 2.06027C6.40247 2.66652 5.26067 3.72122 4.54658 5.05479C3.83248 6.38837 3.58759 7.92334 3.85128 9.41291C4.11496 10.9025 4.8719 12.2601 6.0004 13.2675V22.5L10.5004 19.5L15.0004 22.5V13.281C15.9965 12.3932 16.7059 11.229 17.0381 9.93676ZM13.5004 19.6973L10.5004 17.697L7.5004 19.6973V14.2875C8.43118 14.7551 9.45824 14.999 10.4999 14.9998C11.5415 15.0005 12.5689 14.7582 13.5004 14.292V19.6973Z",
    fill: "#334863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcone);
export default __webpack_public_path__ + "static/media/icone.57d9f63abe387df3ad6e3f1f16d1b89d.svg";
export { ForwardRef as ReactComponent };